import React, { Component } from "react";
import cn from "classnames";
import { getUserSettings, setUserSettings } from "../../services/api";

class MobileNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscribed: false,
      current: false,
      status: "loading",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    getUserSettings()
      .then((settings) => {
        if (settings && settings.cdc && typeof settings.cdc.subscribed !== "undefined") {
          this.setState({
            status: "initial",
            subscribed: settings.cdc.subscribed,
            current: settings.cdc.subscribed,
          });
        } else {
          this.setState({ status: "initial", subscribed: false, current: false });
        }
      })
      .catch(() => {
        this.setState({ status: "update_error" });
      });
  }

  handleChange(value) {
    this.setState({ subscribed: value });
  }

  handleSubmit() {
    this.setState({ status: "loading" }, () => {
      setUserSettings({
        type: "cdc_newsletter",
        values: { subscribed: this.state.subscribed },
      })
        .then(() => {
          this.setState({ status: "update_ok", current: this.state.subscribed });
        })
        .catch(() => {
          this.setState({ status: "update_error" });
        });
    });
  }

  render() {
    const { status, subscribed, current } = this.state;
    const noChange = current === subscribed;

    return (
      <div id="account-menu-container">
        <div className="mobile-notifications-content">
          {status === "loading" && (
            <span className="mobile-notifications-message">
              Updating your notification settings...
            </span>
          )}
          {status === "update_error" && (
            <span className="mobile-notifications-message">
              We're sorry, there was an error updating your notification settings.
              <br />
              Please try again.
            </span>
          )}
          {status === "update_ok" && (
            <span className="mobile-notifications-message">
              Your notification settings have been updated
            </span>
          )}
          {status === "initial" && (
            <>
              <span className="mobile-notifications-message">
                Would you like to receive newsletters from NYA?
              </span>
              <div className="mobile-notifications-options">
                <div
                  className="mobile-notifications-option"
                  onClick={() => this.handleChange(false)}
                >
                  <div className={cn("mobile-notifications-radio", { active: !subscribed })} />
                  <span>NO</span>
                </div>
                <div
                  className="mobile-notifications-option"
                  onClick={() => this.handleChange(true)}
                >
                  <div className={cn("mobile-notifications-radio", { active: subscribed })} />
                  <span>YES</span>
                </div>
              </div>
              <button
                className={cn("mobile-notifications-submit", { disabled: noChange })}
                onClick={!noChange ? this.handleSubmit : undefined}
              >
                SUBMIT
              </button>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default MobileNotifications;
